module.exports = __webpack_public_path__ + "img/bg.313ca403.png";